/**
 * PATCH／PUT body 不帶頂層 `id`：後端以網址識別資源，嚴格解析的 route 會回 400 REQUEST_BODY_INVALID field=id。
 * 只移除頂層；明細列的 `id` 依各 API 文件保留。
 *
 * @param {object} payload
 * @returns {object}
 */
export function omitTopLevelId(payload) {
  if (payload == null || typeof payload !== 'object' || Array.isArray(payload)) {
    return payload;
  }
  const { id: _ignoredId, ...rest } = payload;
  return rest;
}
